import { useMutation, useQuery } from '@tanstack/react-query'
import { store } from '../..'
import { announcements } from '../../../api/hr/announcement'
import { setAlert, setIsLoading } from '../../components/components-slice'
import { queryClient } from '../../..'
import moment from 'moment'

export function useCreateAnnouncement() {
  return useMutation(
    (payload) => {
      return announcements.createAnnouncement(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        store.dispatch(setAlert(true, 'success', response.message))
      },
    }
  )
}

export function useGetAnnouncements(limit, page, search) {
  return useQuery(
    ['announcements', { limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true))
      return announcements.getAnnouncements({
        limit,
        page,
        search,
      })
    },
    {
      select(data) {
        data?.data?.forEach((announcement) => {
          announcement.publish_date = moment(announcement.publish_date).format(
            'MMMM D, YYYY'
          )
          announcement.computedActions = [0, 1]
        })

        return data
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
      // keepPreviousData: true
    }
  )
}

export function useGetScheduledAnnouncements(limit, page, search) {
  return useQuery(
    ['sheduled-announcements', { limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true))
      return announcements.getScheduledAnnouncements({
        limit,
        page,
        search,
      })
    },
    {
      select(data) {
        const recipientTypes = {
          1: 'EMPLOYEES',
          2: 'HEAD OF DEPARTMENTS',
          3: 'TEAM',
          4: 'DEPARTMENT',
          5: 'TEAM LEAD',
          6: 'BRANCH MANAGER',
          7: 'BRANCH',
        }
        data?.data?.forEach((announcement) => {
          announcement.publish_date = moment(announcement.publish_date).format(
            'MMMM D, YYYY'
          )
          const recipient = parseInt(announcement.recipient_type)
          announcement.audience = recipientTypes[recipient]
          announcement.computedActions = [0, 1, 2, 3]
        })

        return data
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
      // keepPreviousData: true
    }
  )
}

export function useDeleteAnnouncement() {
  return useMutation(
    (payload) => {
      return announcements.deleteAnnouncement(payload)
    },
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries('announcement')
        queryClient.invalidateQueries('single-announcement')
        store.dispatch(setAlert(true, 'success', response.message))
      },
    }
  )
}

export function usePublishAnnouncement() {
  return useMutation(
    (payload) => {
      return announcements.publishAnnouncement(payload)
    },
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries('announcement')
        queryClient.invalidateQueries('single-announcement')
        store.dispatch(setAlert(true, 'success', response.message))
      },
    }
  )
}

export function useGetSingleAnnouncement(id) {
  return useQuery(
    ['single-announcement', { id }],
    () => {
      store.dispatch(setIsLoading(true))
      return announcements.getSingleAnnouncement(id)
    },
    {
      enabled: !!id,
      onSuccess: (response, variables, context) => {
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useAddAnnouncementComment() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return announcements.addAnnouncementComment(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('announcement')
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useDeleteAnnouncementComment() {
  return useMutation(
    (payload) => {
      return announcements.deleteComment(payload)
    },
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries('announcement')
        queryClient.invalidateQueries('single-announcement')
        store.dispatch(setAlert(true, 'success', response.message))
      },
    }
  )
}


export function useUpdateAnnouncement() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return announcements.updateAnnouncement(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('announcement')
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}